import axios from 'axios';
import { isEmbroideryTrace } from '../../config/appVariant';
import { aiAccountHeaders } from '../aiUsageApi';
const endpoints = {
  detectImageColors: 'embroideryDetectImageColors',
  analyzeImageForRetrace: 'embroideryAnalyzeImageForRetrace',
  analyzeStitchSettings: 'embroideryAnalyzeStitchSettings',
};
export async function requestAnalysis(operation, body, timeout = 30000) {
  if (!endpoints[operation]) throw new Error('Unknown analysis operation.');
  // Preserve the legacy stitch request's lack of auth outside EmbroideryTrace.
  const headers = { 'Content-Type': 'application/json',
    ...(!isEmbroideryTrace && operation === 'analyzeStitchSettings' ? {} : await aiAccountHeaders()) };
  if (isEmbroideryTrace && !headers.Authorization) throw new Error('Sign in for AI analysis.');
  return axios.post(`https://us-central1-svgtrace-pro.cloudfunctions.net/${isEmbroideryTrace ? endpoints[operation] : operation}`,
    isEmbroideryTrace ? {...body, requestId: crypto.randomUUID()} : body, {headers, timeout});
}
